var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referral_purchase" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "300px" },
            attrs: { placeholder: "请输入活动名称", clearable: "" },
            on: { clear: _vm.search },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search($event)
              },
            },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.search },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addActivity },
            },
            [_vm._v("\n      新增活动\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "referralId",
              label: "活动ID",
              width: "180",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "activityName",
              label: "活动名称",
              width: "200",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "menuTypeList",
              label: "点餐类型",
              width: "180",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.menuTypeList, function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.code,
                        staticStyle: { "margin-right": "1px" },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.desc) + "\n        "
                        ),
                      ]
                    )
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "执行周期", width: "280", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.executeCycleBean &&
                    scope.row.executeCycleBean.code === "range_date"
                      ? _c("div", [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                scope.row.startDateStr +
                                  " ~ " +
                                  scope.row.endDateStr
                              )
                            ),
                          ]),
                        ])
                      : scope.row.executeCycleBean &&
                        scope.row.executeCycleBean.code === "weekly"
                      ? _c("div", [
                          _c(
                            "div",
                            _vm._l(scope.row.weeks, function (item) {
                              return _c(
                                "el-tag",
                                {
                                  key: item,
                                  staticStyle: { "margin-right": "3px" },
                                  attrs: { size: "mini" },
                                },
                                [_vm._v(_vm._s(item) + "\n            ")]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          scope.row.startDateStr && scope.row.endDateStr
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "4px",
                                    color: "#909399",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.startDateStr +
                                          " ~ " +
                                          scope.row.endDateStr
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "执行时间", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.startTimeStr + " ~ " + scope.row.endTimeStr
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "适用门店", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.storeScope === 0
                      ? _c(
                          "span",
                          [
                            _c("el-tag", [
                              _vm._v("\n            全部店铺\n          "),
                            ]),
                          ],
                          1
                        )
                      : scope.row.storeScope === 1
                      ? _c(
                          "span",
                          [
                            _vm._l(
                              (scope.row.storeNameList || []).slice(0, 3),
                              function (item) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item,
                                    staticStyle: { "margin-right": "3px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(item) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            (scope.row.storeNameList || []).length > 3
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      "popper-class": "store-name-tooltip",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "max-width": "300px",
                                          "max-height": "200px",
                                          "overflow-y": "auto",
                                          "white-space": "normal",
                                          "word-break": "break-all",
                                          "line-height": "1.5",
                                        },
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              scope.row.storeNameList.join("、")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tag",
                                      { staticStyle: { cursor: "pointer" } },
                                      [_vm._v("...")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-value": true,
                        "inactive-value": false,
                        "active-color": "#13ce66",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.markForEnable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "markForEnable", $$v)
                        },
                        expression: "scope.row.markForEnable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }